import React, { Fragment } from 'react'
import { slugToTitleCase } from 'config/libraries';
import { TagNavigation } from './tag-navigation';

export const Detail = ({DataResponse}) => {
    return (
        <Fragment>
            <div className="jl_single_style2">
                <div className="single_post_entry_content single_bellow_left_align jl_top_single_title jl_top_title_feature">
                    <span className="meta-category-small single_meta_category">
                        <a className="post-category-color-text" style={{background: '#eba845'}} href="#">{slugToTitleCase(DataResponse.slug_halaman)}</a>
                    </span>
                    <h1 className="single_post_title_main">{DataResponse.judul_halaman}</h1>
                    <div className="post_subtitle_text" dangerouslySetInnerHTML={{ __html: DataResponse.konten_halaman }}></div>
                    <span className="jl_post_meta">
                        <span className="jl_author_img_w"><i className="jli-user" />
                            <span href="#" title={DataResponse.dibuat_oleh} rel="author">{DataResponse.dibuat_oleh}</span>
                        </span>
                        <span className="post-date">
                            <i className="jli-pen" />{DataResponse.created_at}
                        </span>
                    </span>
                </div>
            </div>
            <div className="clearfix" ></div>
            <TagNavigation />
        </Fragment>
    )
};